if (!customElements.get('cart-drawer-upsell')) {
  customElements.define(
    'cart-drawer-upsell',
    class CartDrawerUpsell extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-upsell-track]');
        this.slides = this.track ? Array.from(this.querySelectorAll('[data-upsell-slide]')) : [];
        if (!this.track || this.slides.length === 0) return;

        this.index = 0;
        this.controls = this.querySelector('[data-upsell-controls]');
        this.prevBtn = this.querySelector('[data-upsell-prev]');
        this.nextBtn = this.querySelector('[data-upsell-next]');
        this.dotsRoot = this.querySelector('[data-upsell-dots]');
        this.autoplay = this.dataset.autoplay === 'true';
        this.autoplaySpeed = parseInt(this.dataset.autoplaySpeed, 10) || 5000;
        this.autoplayTimer = null;
        this.pauseAutoplay = false;

        this.track.style.width = `${this.slides.length * 100}%`;
        this.slides.forEach((el) => {
          el.style.width = `${100 / this.slides.length}%`;
        });

        this.buildDots();
        this.goTo(0, false);

        if (this.slides.length > 1) {
          this.controls.hidden = false;
          this.prevBtn.addEventListener('click', () => this.goTo(this.index - 1));
          this.nextBtn.addEventListener('click', () => this.goTo(this.index + 1));
          this.addEventListener('mouseenter', () => {
            this.pauseAutoplay = true;
            this.stopAutoplay();
          });
          this.addEventListener('mouseleave', () => {
            this.pauseAutoplay = false;
            this.startAutoplay();
          });
          this.addEventListener('focusin', () => {
            this.pauseAutoplay = true;
            this.stopAutoplay();
          });
          this.addEventListener('focusout', (e) => {
            if (!this.contains(e.relatedTarget)) {
              this.pauseAutoplay = false;
              this.startAutoplay();
            }
          });
          this.startAutoplay();
        }

        this.querySelectorAll('[data-upsell-add]').forEach((btn) => {
          btn.addEventListener('click', (e) => this.onAddToCart(e.currentTarget));
        });

        // Size pill selection: clicking a pill updates the slide's Add button
        // to use that variant ID, and toggles visual + aria state.
        this.querySelectorAll('[data-upsell-sizes]').forEach((group) => {
          group.addEventListener('click', (e) => {
            const pill = e.target.closest('[data-upsell-size]');
            if (!pill || !group.contains(pill)) return;
            if (pill.getAttribute('aria-disabled') === 'true') return;

            const slide = pill.closest('[data-upsell-slide]');
            if (!slide) return;
            const variantId = pill.dataset.variantId;
            if (!variantId) return;

            group.querySelectorAll('[data-upsell-size]').forEach((p) => {
              p.classList.remove('is-selected');
              p.setAttribute('aria-pressed', 'false');
            });
            pill.classList.add('is-selected');
            pill.setAttribute('aria-pressed', 'true');

            const addBtn = slide.querySelector('[data-upsell-add]');
            if (addBtn) addBtn.dataset.variantId = variantId;
          });
        });
      }

      disconnectedCallback() {
        this.stopAutoplay();
      }

      buildDots() {
        if (!this.dotsRoot || this.slides.length < 2) return;
        this.dotsRoot.innerHTML = '';
        this.dots = [];
        this.slides.forEach((_, i) => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'cart-drawer-upsell__dot';
          dot.setAttribute('role', 'tab');
          dot.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
          dot.setAttribute('aria-label', `${i + 1}`);
          dot.addEventListener('click', () => this.goTo(i));
          this.dotsRoot.appendChild(dot);
          this.dots.push(dot);
        });
      }

      goTo(nextIndex, animate = true) {
        const n = this.slides.length;
        if (n === 0) return;
        let i = nextIndex % n;
        if (i < 0) i += n;
        this.index = i;
        const pct = (i / n) * 100;
        this.track.style.transition = animate ? '' : 'none';
        this.track.style.transform = `translateX(-${pct}%)`;

        this.slides.forEach((slide, idx) => {
          slide.setAttribute('aria-hidden', idx === i ? 'false' : 'true');
        });

        if (this.dots) {
          this.dots.forEach((dot, idx) => {
            dot.setAttribute('aria-selected', idx === i ? 'true' : 'false');
            dot.classList.toggle('is-active', idx === i);
          });
        }
      }

      startAutoplay() {
        this.stopAutoplay();
        if (!this.autoplay || this.slides.length < 2 || this.pauseAutoplay) return;
        this.autoplayTimer = window.setInterval(() => {
          if (document.hidden) return;
          this.goTo(this.index + 1);
        }, this.autoplaySpeed);
      }

      stopAutoplay() {
        if (this.autoplayTimer) {
          clearInterval(this.autoplayTimer);
          this.autoplayTimer = null;
        }
      }

      onAddToCart(button) {
        const variantId = button.dataset.variantId;
        if (!variantId || button.getAttribute('aria-disabled') === 'true') return;

        const cartDrawer = document.querySelector('cart-drawer');
        const addText = button.querySelector('[data-upsell-add-text]');
        const spinner = button.querySelector('.cart-drawer-upsell__spinner');
        const slide = button.closest('[data-upsell-slide]');
        const errorEl = slide ? slide.querySelector('[data-upsell-error]') : null;
        const addLabel = button.dataset.addLabel || '';
        const addingLabel = button.dataset.addingLabel || '…';

        button.setAttribute('aria-disabled', 'true');
        if (addText) addText.textContent = addingLabel;
        if (spinner) spinner.classList.remove('hidden');
        if (errorEl) {
          errorEl.classList.add('hidden');
          errorEl.textContent = '';
        }

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', '1');
        if (cartDrawer) {
          formData.append(
            'sections',
            cartDrawer.getSectionsToRender().map((s) => s.id).join(',')
          );
          formData.append('sections_url', window.location.pathname);
        }
        config.body = formData;

        fetch(`${window.routes.cart_add_url}`, config)
          .then((r) => r.json())
          .then((response) => {
            if (response.status) {
              if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
                publish(PUB_SUB_EVENTS.cartError, {
                  source: 'cart-drawer-upsell',
                  productVariantId: variantId,
                  errors: response.errors || response.description,
                  message: response.message,
                });
              }
              if (errorEl) {
                errorEl.textContent = response.description || response.message || window.cartStrings?.error || '';
                errorEl.classList.remove('hidden');
              }
              return;
            }

            if (!cartDrawer) {
              window.location.href = window.routes.cart_url;
              return;
            }

            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'cart-drawer-upsell',
                productVariantId: variantId,
                cartData: response,
              });
            }

            if (typeof CartPerformance !== 'undefined' && CartPerformance.measure) {
              CartPerformance.measure('add:paint-updated-sections', () => {
                cartDrawer.renderContents(response);
              });
            } else {
              cartDrawer.renderContents(response);
            }
          })
          .catch(() => {
            if (errorEl) {
              errorEl.textContent = window.cartStrings?.error || '';
              errorEl.classList.remove('hidden');
            }
          })
          .finally(() => {
            button.removeAttribute('aria-disabled');
            if (addText) addText.textContent = addLabel;
            if (spinner) spinner.classList.add('hidden');
          });
      }
    }
  );
}
